var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeRequestsEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76601 16.3777L25.8231 4.28602C29.5538 1.91892 34.492 3.0275 36.8529 6.76211L48.8715 25.7738C51.2324 29.5084 50.122 34.4549 46.3913 36.822L27.3342 48.9136C23.6035 51.2807 18.6653 50.1721 16.3044 46.4375L4.2858 27.4258C1.92489 23.6912 3.03532 18.7448 6.76601 16.3777Z",
    fill: "#feb101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7725 42.1853L30.6747 31.9155C28.1649 28.2841 29.0708 23.306 32.6991 20.7917L41.6755 14.571L44.2383 12.7932C47.8718 10.2727 52.8609 11.1781 55.377 14.8146L63.2116 26.1381C65.7236 29.7687 64.8197 34.7478 61.1919 37.2637L49.6441 45.2726C46.005 47.7964 41.0079 46.8836 38.4961 43.2361L37.7725 42.1853ZM59.0166 36.852C62.6451 34.3359 63.5488 29.3558 61.0359 25.7251L54.987 16.9858C52.4711 13.3508 47.4839 12.4455 43.8509 14.9642L42.5306 15.8795L34.8833 21.1861C31.2572 23.7023 30.354 28.6799 32.8648 32.3098L39.1095 41.3374C41.5155 44.8144 46.2858 45.6803 49.7604 43.2708L59.0166 36.852Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRequestsEmpty);
export default __webpack_public_path__ + "static/media/home-requests-empty.1d458eb1347381a86ae5e489bd705f10.svg";
export { ForwardRef as ReactComponent };